module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA9klEQVQ4jbXTzyqEYRTH8c8zTaFYUGYvUe7AwkbZyHKSrGajcQsTaxPXYIGaLMRCsZpLcQlThI2Y17GYiYl3RkZz6tQ5v3PO9/nT88giqlnEUxYRQ/hjFrGTsoh7TBveHlIWEf8AgGK/wl/IeZBm0MzRV7GeC8lZsYT5nN5Sv52k9oju5BY3A2bWUP4NMoeVAZDF78LIjjMUpIXZfzBaqR2xhUNMDWicxFhP/ornrtdSu3b6VUp9EPXKAq6x1FUu7Tc2oXE0oeil0JHH3ztvPQ+0d3anXlnGOTbw+S/ekI5ddBi9Q4UfAdjOygUcYOakeLUbqCY+ALMMe1DI5BOhAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/center/menu/msg1.png
// module id = N17l
// module chunks = 26